// extracted by mini-css-extract-plugin
export default {"async-img":"async-img_async-img__8WDUk","async-img--loaded":"async-img_async-img--loaded__Yj0U0"};